import listTemplate from './templates/vacancy-list.twig';
import {Utils} from '../../common/scripts/utils';

class Vacancy {
    constructor(options) {
        this.wrapper = options.wrapper;
        this.overlay = document.querySelector('.j-vacancy__overlay');
        this.selectorsWrapper = document.querySelector('.j-vacancy__selector') || null;
        this.selectors = Array.from(this.selectorsWrapper.querySelectorAll('.j-vacancy__selector-item'));
        this.activeProfession = this.wrapper.dataset.profession;
        this.mobileSelector = document.querySelector('.j-vacancy__mobile');
        this.mobileSelectorText = this.mobileSelector.querySelector('.j-vacancy__mobile-text');
        this.defaultOrder = 'desc';
        this.sortBtns = Array.from(this.wrapper.querySelectorAll('.j-vacancy__sort'));
        this.sort = null;
        this.sortOrder = this.defaultOrder;
        this.list = this.wrapper.querySelector('.j-vacancy__list');
        this.more = this.wrapper.querySelector('.j-vacancy__more');
        this.moreText = this.more ? this.more.querySelector('.j-vacancy__more-text') : null;
        this.total = this.wrapper.querySelector('.j-vacancy__total');
        this.url = options.url;
    }

    init() {
        this._bindEvents();
    }

    // Вешаем слушателя на нажатия кнопок
    _bindEvents() {
        this._listenSelectors();

        // Мобильный выбор специальности
        if (this.mobileSelector) {
            this.mobileSelector.addEventListener('click', () => {
                this.selectorsWrapper.classList.toggle('is-active');
                this.overlay.classList.toggle('is-active');
            });
        }

        // Кнопки сортировки
        this.sortBtns.forEach((button) => {
            button.addEventListener('click', () => {
                this._sorting(button);

                this._loadResult(this._collectData('sort', this.activeProfession), true);
            });
        });

        // Кнопка показать еще
        this.more.addEventListener('click', () => {
            this._loadResult(this._collectData('more', this.activeProfession));
        });
    }

    /**
     * Следим за событием нажатия кнопок выбора специальности
     */
    _listenSelectors() {
        // Список выбора специальности
        if (this.selectorsWrapper) {
            this.selectors.forEach((selector) => {
                selector.addEventListener('click', () => {
                    const profession = selector.dataset.profession;

                    if (Utils.getWindowWidth() < 1280) {
                        const selected = selector.querySelector('.j-vacancy__selector-text').innerText;

                        this.mobileSelectorText.innerText = selected;
                        this.selectorsWrapper.classList.toggle('is-active');
                        this.overlay.classList.toggle('is-active');
                    }

                    if (profession !== this.activeProfession) {
                        this.activeProfession = profession;
                        this.wrapper.dataset.profession = profession;
                        this.more.dataset.shown = 0;
                        this._loadResult(this._collectData('change', profession), true);
                    }
                });
            });
        }
    }

    /**
     * Задаем параметры сортировки по нажатию кнопки
     * @param {object} button - объект нажатой кнопки сортировки
     */
    _sorting(button) {
        if (this.sort === button.dataset.sort) {
            this.sortOrder = this.sortOrder === 'desc' ? 'asc' : 'desc';
            button.dataset.order = this.sortOrder;
        } else {
            // Находим предыдущую сортировку и снимаем с нее активный класс
            const prevSort = this.wrapper.querySelector(`.button[data-sort="${this.sort}"]`);

            if (prevSort) {
                prevSort.classList.remove('is-active');
            }

            // Устанавливаем новую сортировку
            this.sort = button.dataset.sort;
            this.sortOrder = this.defaultOrder;

            button.classList.add('is-active');
        }
    }

    _loadResult(formData, isReplace = false) {
        const that = this;

        Utils.send(formData, this.url, {
            success(response) {
                const {data} = response;
                const more = data.more;

                if (isReplace) {
                    Utils.clearHtml(that.list);
                }

                Utils.insetContent(that.list, listTemplate(data));

                // Устанавливаем надпись в кнопке или прячем ее
                if (more.more) {
                    that.moreText.innerText = more.text;

                    if (that.more.classList.contains('is-hidden')) {
                        that.more.classList.remove('is-hidden');
                    }
                } else {
                    that.more.classList.add('is-hidden');
                }

                that.more.dataset.shown = more.count;

                // Устанавливаем надпись об общем показаном количестве вакансий
                that.total.innerText = `${more.showWord} ${more.count} ${more.word} из ${more.total}`;
            }
        }, 'POST');
    }

    /**
     * Формируем данные для отправки на сервер
     * @param {string} request - тип запроса, т.е. Показать еще, отсортировать или изменить специальность
     * @param {string} profession - специальность на которую надо изменить
     * @returns {object} возвращает данные формы
     */
    _collectData(request, profession = null) {
        const formData = new FormData();

        formData.append('type', request);
        formData.append('sort', this.sort);
        formData.append('order', this.sortOrder);
        formData.append('profession', profession);
        formData.append('shown', this.more.dataset.shown);

        return formData;
    }
}

export default Vacancy;
